/**
 * @generated SignedSource<<47b7cee2cc46085175f0e71e952407c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AutoRecordToggle_AutoRecordIsOnForStream$variables = {
  id: string;
};
export type AutoRecordToggle_AutoRecordIsOnForStream$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"AutoRecordToggle_refetchableAutoRecordIsOnForStream">;
  } | null;
};
export type AutoRecordToggle_AutoRecordIsOnForStream = {
  response: AutoRecordToggle_AutoRecordIsOnForStream$data;
  variables: AutoRecordToggle_AutoRecordIsOnForStream$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AutoRecordToggle_AutoRecordIsOnForStream",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AutoRecordToggle_refetchableAutoRecordIsOnForStream"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AutoRecordToggle_AutoRecordIsOnForStream",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "schedulingMeetingAssistantAutomationIsActive",
                "storageKey": null
              }
            ],
            "type": "NoteStream",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "92c6a67ec55df474848b4cac56cb8a20",
    "id": null,
    "metadata": {},
    "name": "AutoRecordToggle_AutoRecordIsOnForStream",
    "operationKind": "query",
    "text": "query AutoRecordToggle_AutoRecordIsOnForStream(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...AutoRecordToggle_refetchableAutoRecordIsOnForStream\n    id\n  }\n}\n\nfragment AutoRecordToggle_refetchableAutoRecordIsOnForStream on NoteStream {\n  schedulingMeetingAssistantAutomationIsActive\n  id\n}\n"
  }
};
})();

(node as any).hash = "7b166994edf2c813147b7790d3f852f3";

export default node;
